import { createSlice } from "@reduxjs/toolkit";

const welfareSlice = createSlice({
    name: "welfare",
    initialState: {
        isLoadingWelfare: false,
        welfareWorkflow: {}
    },
    reducers: {
        setIsLoadingWelfare(state, action) {
            state.isLoadingWelfare = action.payload;
        },
        setWelfareWorkflow(state, action) {
            state.welfareWorkflow = action.payload;
        },
    },
});

export const {
    setIsLoadingWelfare,
    setWelfareWorkflow
} = welfareSlice.actions;
export default welfareSlice.reducer;
